import type { SystemRuntimeOrigin } from '../types/common.types';
import type { System } from '../types/system.types';

export const getSystemsCurlCommand = (subUrl: string, token: string, internal: boolean = false) => {
  if (!subUrl || !token) {
    return 'Error: Base url or token is missing!';
  }

  return `curl \
    -H "Authorization: bearer ${token}" \
    "${subUrl}/systems${internal ? '?include-internal-systems=true' : ''}"`;
};
